import { createReducer, on } from '@ngrx/store';
import * as pageActions from '../actions/menu.action';
import * as utility from '../../../utility';
import { Menu } from '../../models';

export interface MenusState {
  entities: { [handle: string]: Menu };
  loaded: boolean;
  loading: boolean;
  error?: any;
}

export const initialState: MenusState = {
  entities: {},
  loaded: false,
  loading: false,
};

export const MenuReducer = createReducer(
  initialState,
  on(pageActions.LoadMenuByHandle, (state: MenusState) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(pageActions.LoadMenuByHandleSuccess, (state: MenusState, { menu }) => {
    const entities = { ...state.entities, [menu.handle]: menu };
    return {
      ...state,
      entities,
      loading: false,
    };
  })
);

export const getMenusEntities = (state: MenusState) => state.entities;
export const getMenuLoading = (state: MenusState) => state.loading;
